<template>
  <div class="sm:items-start sm:flex-row flex flex-col justify-between items-center my-4 sm:mt-0 xl:px-16">
    <div class="proof">
      <img
        :src="bestServiceImage"
        alt="Лучший сервис"
        loading="lazy"
      />
      <h3 class="font-semibold text-[28px] md:text-2xl mb-3 mt-4">
        {{ $t('index.proofs.convenient.head') }}
      </h3>
      <p>
        {{ $t('index.proofs.convenient.text') }}
      </p>
    </div>
    <div class="proof">
      <img
        :src="peaceOfMindImage"
        alt="Спокойствие"
        loading="lazy"
      />
      <h3 class="font-semibold text-[28px] md:text-2xl mb-3 mt-4">
        {{ $t('index.proofs.safely.head') }}
      </h3>
      <p>
        {{ $t('index.proofs.safely.text') }}
      </p>
    </div>
    <div class="proof">
      <img
        :src="fullSupportImage"
        alt="Полная поддержка"
        loading="lazy"
      />
      <h3 class="font-semibold text-[28px] md:text-2xl mb-3 mt-4">
        {{ $t('index.proofs.easy.head') }}
      </h3>
      <p>
        {{ $t('index.proofs.easy.text') }}
      </p>
    </div>
  </div>
</template>

<script setup>
import bestServiceImage from '~/assets/png/index/proofs/best-service.png'
import peaceOfMindImage from '~/assets/png/index/proofs/peace-of-mind.png'
import fullSupportImage from '~/assets/png/index/proofs/full-support.png'
</script>

<style lang="sass" scoped>
  .proof
    @apply max-w-75 sm:max-w-64 lg:max-w-75 flex flex-col justify-center items-center my-4 gap-2 sm:px-2
    img
      @apply w-full max-w-75 px-2 sm:h-36 sm:w-auto
    h3
      @apply font-semibold text-[28px] md:text-2xl mb-3 mt-4 sm:text-2xl lg:text-[28px] lg:mb-1
    p
      @apply text-center text-lg leading-tight sm:text-sm font-normal text-gray-sub-text-2 lg:text-lg lg:leading-6
</style>
